<template>
  <websiteview
    :isDesktop="isDesktop"
    :selectedOption="selectedOption"
    :searchedFilter="searchedFilter" >
  </websiteview>
</template>

<script>
import { computed, watch, ref } from "vue";
import websiteview from "@/containers/websiteview.vue";
import { i18n } from '@/main.js';
import colors from './colors.js'
import apiservice from "@/services/apiservice.js";

import { useMenuStore } from "./stores/menu.ts";
import { useEventSearch } from "./stores/eventSearch.ts";
import { useHorarios } from "./stores/horarios.ts";

import { getFormHook } from '@/hooks/FormFactory.js';

export default {
  components: {
    websiteview,
  },
  data() {
    return {
      context: import.meta.env.VITE_APP_CONTEXT
    }
  },
  setup(props){

    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const ciclo = urlParams.get("ciclo") || null;
    const ano = parseInt(urlParams.get("ano")) || null;
    const curso = urlParams.get("curso") || null;
    const cursoid = urlParams.get("curso") || null;
    const turma = urlParams.get("turma") || null;
    const disciplina = urlParams.get("disciplina") || null;
    const docente = urlParams.get("docente") || null;
    const avaliacao = urlParams.get("avaliacao") || null;
    const sala = urlParams.get("sala") || null;
    const start = urlParams.get("start") || null;
    const end = urlParams.get("end") || null;
    const sopt = urlParams.get("selectedOption") || null;

    const eventsearch = useEventSearch();
    const searchedFilter = computed(()=> eventsearch.searchedFilter);

    const menuStore = useMenuStore();
    const selectedOption = computed(() => menuStore.currentSelected);
    const options = computed(() => menuStore.menuItems);

    const isDesktop = ref(true);
    const checkScreenSize = () => {
      isDesktop.value = window.innerWidth >= 768; // adjust breakpoint as needed
    }

    const horariosStore = useHorarios();

    if(sopt != null){
      const initOption = options.value.find(el => el.value == sopt);
      menuStore.selectMenuItem(initOption.id);
      const selectedDates = { start: new Date(start),  end: new Date(end) };
      const filtersToLoad = {
        ciclo: ciclo,
        ano: {value:ano},
        curso: curso,
        cursoid: curso,
        disciplina: {value:disciplina},
        turma: {valor:turma},
        sala: {IdSala:sala},
        docente: {value:docente},
        avaliacao: {valor:avaliacao},
        selectedWeek: selectedDates,
        date: selectedDates,
        selectedOption: initOption
      }
      eventsearch.updateCurrentFilters(filtersToLoad);
      eventsearch.setSelectedWeek(selectedDates);
      eventsearch.updateSearchFilter(initOption);

      const hook = getFormHook(initOption.id)(false,eventsearch.currentFilters);
      horariosStore.setIsUpdatingHorario(true);
      hook.getOptions(selectedDates,"pt").
        then(options => {
          const searchedFormValuesToLoad = hook.form;
          for(let prop in searchedFormValuesToLoad){
            const kval = filtersToLoad[prop]?.value ?? 
              filtersToLoad[prop]?.valor ?? 
              filtersToLoad[prop]?.IdSala ?? 
              filtersToLoad[prop];
            const val = prop != "sala" ? options[prop].find(el => el.valor == kval) :
                       options[prop].find(el => el.value == kval);
            searchedFormValuesToLoad[prop].value = val;
          }
          eventsearch.setSearchedFormValues(searchedFormValuesToLoad);
          horariosStore.fetchHorario();
        });
    }

    return {
      isDesktop,
      checkScreenSize,
      searchedFilter,
      selectedOption
    }

  },
  mounted(){
    window.addEventListener("resize", this.checkScreenSize);
    this.checkScreenSize();
  },
  provide() {
    return {
      lang: computed(() => i18n.global.locale),
    }
  }
}

</script>

<style>
@font-face {
  font-family: "Montserrat Black";
  src: url("./assets/fonts/Montserrat-Black.otf") format("opentype");
  font-display: swap;
}

@font-face {
  font-family: "Montserrat Bold";
  src: url("./assets/fonts/Montserrat-Bold.otf") format("opentype");
  font-display: swap;
}

@font-face {
  font-family: "Montserrat Light";
  font-display: swap;
  src: url("./assets/fonts/Montserrat-Light.otf") format("opentype");
}

@font-face {
  font-family: "Montserrat";
  font-display: swap;
  src: url("./assets/fonts/Montserrat-Regular.otf") format("opentype");
}

@font-face {
  font-family: "Montserrat SemiBold";
  font-display: swap;
  src: url("./assets/fonts/Montserrat-SemiBold.otf") format("opentype");
}

@font-face {
  font-family: "Montserrat Thin";
  font-display: swap;
  src: url("./assets/fonts/Montserrat-Thin.otf") format("opentype");
}

@font-face {
  font-family: "PT Sans";
  src: url("./assets/fonts/PTSans.woff2") format('woff2');
}

@font-face {
  font-family: "PT Sans Italic";
  src: url("./assets/fonts/PTSansItalic.woff2") format('woff2');
}

@font-face {
  font-family: "PT Sans Bold Italic";
  src: url("./assets/fonts/PTSansBoldItalic.woff2") format('woff2');
}


html{
  font-size: 100%;
  box-sizing: border-box;
}

*,:after,:before {
    box-sizing: inherit
}

blockquote,dd,div,dl,dt,form,h1,h2,h3,h4,h5,h6,li,ol,p,pre,td,th,ul {
    margin: 0;
    padding: 0
}

p {
    margin-bottom: 1rem;
    font-size: inherit;
    line-height: 1.6;
    text-rendering: optimizeLegibility
}

button {
    padding: 0;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border: 0;
    border-radius: 0;
    background: transparent;
    line-height: 1
}

.dropdown-pane {
    position: absolute;
    z-index: 10;
    display: block;
    width: 300px;
    padding: 1rem;
    visibility: hidden;
    border: 1px solid #cacaca;
    border-radius: 0;
    background-color: #fefefe;
    font-size: 1rem
}

.dropdown-pane.is-open {
    visibility: visible
}

button,input,optgroup,select,textarea {
    font-family: sans-serif;
    font-size: 100%;
    line-height: 1.15;
    margin: 0
}

body{
  height: 100%;
  margin: 0;
  font-weight: 400;
  line-height: 1.5;
  color: #0a0a0a;
  -webkit-font-smoothing: antialiased;
}

.wrapper {
  padding-top: 40px;
  padding-bottom: 40px;
  padding-left: 7%;
  padding-right: 7%;
  position: relative;
}

@media (max-width:1600px) {
  .wrapper {
    padding-left: 7%;
    padding-right: 7%;
  }
}

.dateselector {
  margin-bottom: 20px;
}


@media only screen and (max-width: 767px) {
  .wrapper{
    padding-top: 15px;
  }
}
</style>
